import React, { Fragment, useState } from "react";
import DatePicker from "react-datepicker";
import InputLabel from "@material-ui/core/InputLabel";

const ReactDatePicker = ({ filterInputsUpdateKey, label, name, value }) => {
    const [startDate, setStartDate] = useState(value);
    const handleChange = (date, name) => {
        if (date) {
            let convertDate = new Date(

                date.getTime() - date.getTimezoneOffset() * 60000
            ).toISOString();

            convertDate = convertDate.split("T").join(" ");
            convertDate = convertDate.split(".")[0];
            
            // let newD = convertDate.split('-').map(n => {
            //     return parseInt(n)
            // }).join('-')

            // console.log(newD);

            // let convertDates = convertDate.split(".")[0].split(" ")[1];

            // console.log(convertDates);

            // convertDate = newD + " " + convertDates

            console.log(convertDate);

            // let d = '11-10-2018';
            // let newD = convertDate.split('-').map(n => {
            //     return parseInt(n)
            // }).join('-')
            // console.log(newD);

            //    let a = new Date().toISOString()
            //     new Date().toISOString().split('T')[0];
            //     new Date().toISOString().replace('-', '/').split('T')[0].replace('-', '/');


            setStartDate(date);

            filterInputsUpdateKey(name, convertDate);
        } else {
            setStartDate("");
            filterInputsUpdateKey(name, "");
        }

    };
    return (
        <Fragment>
            <InputLabel>{label}</InputLabel>

            <DatePicker
                dateFormat="yyyy/MM/d HH:mm:ss"
                timeFormat="HH:mm:ss"
                timeIntervals={1}
                selected={startDate}
                onChange={(date) => handleChange(date, name)}
                showTimeSelect
                showMonthDropdown
                showYearDropdown
                placeholderText="yyyy/MM/d HH:mm:ss"
            />
        </Fragment>
    );
};

export default ReactDatePicker;
